import { gql, useQuery } from "@apollo/client";

export const useLibraryCategory = (id: string) => {
  return useQuery(gql`
    query getLibraryCategory($_id: MongoID!) {
      library_category(_id: $_id) {
        _id
        name
        parent_id
        parent_ids
        using_organisation_ids
        parent {
          _id
          name
        }
        parents {
          _id
          name
        }
      }
    }
  `, 
  {
    variables: { _id: id },
    fetchPolicy: "network-only",
  }
);
}